import React from 'react';
import './profileMenu.scss';

const AnonymousUserProfileMenu = ({ loginUrl, AnonymousUserIcon }) => {
  function onHandleLogin() {
    window.open(loginUrl, '_self');
  }

  return (
    <ul className="dropdown-menu">
      <li className="item" key="login">
        <a data-testid="login-link" onClick={onHandleLogin}>
          <AnonymousUserIcon className="icon" />
          Aanmelden
        </a>
      </li>
    </ul>
  );
};

export default AnonymousUserProfileMenu;
